import { Project } from '@/lib/types'
import { Card, Badge, Tag } from '@/ui'

interface TechnicalCardProps {
  project: Project
}

export function TechnicalCard({ project }: TechnicalCardProps) {
  // Filter out tags that are already in stack to avoid duplicates
  const stackLowerCase = project.stack.map((s) => s.toLowerCase())
  const uniqueTags = project.tags.filter((tag) => !stackLowerCase.includes(tag.toLowerCase()))

  return (
    <Card hover className="p-5 border-l-4 border-blue-500 dark:border-blue-400">
      <div className="flex items-start justify-between mb-3">
        <h3 className="text-lg font-bold dark:text-gray-100">{project.title}</h3>
        <Badge variant={project.public ? 'success' : 'default'} size="sm">
          {project.public ? 'Public' : 'Private'}
        </Badge>
      </div>

      <p className="text-sm text-gray-600 mb-3 dark:text-gray-400">{project.one_liner}</p>

      {/* Stack */}
      <div className="mb-3">
        <p className="text-xs font-semibold text-gray-500 mb-1 dark:text-gray-400">Stack:</p>
        <div className="flex flex-wrap gap-1">
          {project.stack.map((tech, i) => (
            <Badge key={i} variant="primary" size="sm">
              {tech}
            </Badge>
          ))}
        </div>
      </div>

      {/* Ops Layer (compact) */}
      {project.ops_layer && (
        <div className="text-xs text-gray-600 bg-gray-50 p-2 rounded mb-3 dark:bg-gray-700 dark:text-gray-300">
          <div>
            <strong>CI/CD:</strong> {project.ops_layer.cicd}
          </div>
        </div>
      )}

      {/* Tags (only unique ones not in stack) */}
      {uniqueTags.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {uniqueTags.map((tag, i) => (
            <Tag key={i}>{tag}</Tag>
          ))}
        </div>
      )}
    </Card>
  )
}
